import { dAppName } from 'config';
import Esdt from 'pages/Esdt';
import Faucet from 'pages/Faucet';
import Team from 'pages/Team';
import { RouteType } from 'types';
import { withPageTitle } from './components/PageTitle';

import { Dashboard, Home, SignMessage, Statistics } from './pages';

export const routeNames = {
  home: '/',
  dashboard: '/dashboard',
  statistics: '/statistics',
  signMessage: '/sign-message',
  unlock: '/unlock',
  faucet: '/faucet',
  esdt: '/esdt'
};

interface RouteWithTitleType extends RouteType {
  title: string;
}

export const routes: RouteWithTitleType[] = [
  {
    path: routeNames.home,
    title: 'Home',
    component: Home
  },
  {
    path: '/faucet',
    title: 'Faucet',
    component: Faucet
  },
  {
    path: routeNames.statistics,
    title: 'Statistics',
    component: Statistics,
    authenticatedRoute: true
  },
  {
    path: routeNames.dashboard,
    title: 'Dashboard',
    component: Dashboard,
    authenticatedRoute: true
  },
  {
    path: routeNames.signMessage,
    title: 'Sign Message',
    component: SignMessage,
    authenticatedRoute: true
  },
  {
    path: '/team',
    title: 'Team',
    component: Team
  },
  {
    path: '/esdt',
    title: 'Esdt',
    component: Esdt
  }
];

export const mappedRoutes = routes.map((route) => {
  const title = route.title
    ? `${route.title} • MultiversX ${dAppName}`
    : `MultiversX ${dAppName}`;

  const requiresAuth = Boolean(route.authenticatedRoute);
  const wrappedComponent = withPageTitle(title, route.component);

  return {
    path: route.path,
    component: wrappedComponent,
    authenticatedRoute: requiresAuth
  };
});
